<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('dispositifPublicitaire.caracteristiques') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-2 mgb-10px">
          <app-logo
            :canConserveAncienne="true"
            @hasNewFile="logoChanged">
          </app-logo>
        </div>
        <div class="column is-10">
          <div class="columns is-12 is-multiline">
            <div class="column is-3">
              <b-field :label="$t('dispositifPublicitaire.code')"
                :class="{'obligatoire' : !societeActive.masqueCodeDispositif}">
                <b-input v-model="dispositifPublicitaire.code"></b-input>
              </b-field>
            </div>
            <div class="column is-3" v-if="moduleEmplacementClientActive">
              <b-field :label="$t('dispositifPublicitaire.nom')">
                <b-input v-model="dispositifPublicitaire.nom"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <parametre-autocomplete
                :label="$t('dispositifPublicitaire.support')"
                v-model="dispositifPublicitaire.dispositifSupportId"
                :target="PARAMETRES_KEYS.dispositifSupport"
                />
            </div>
            <div class="column is-3">
              <parametre-autocomplete
                :label="$t('dispositifPublicitaire.TypeDispositif')"
                v-model="dispositifPublicitaire.dispositifTypeId"
                :target="PARAMETRES_KEYS.dispositifType"
                />
            </div>
          </div>
          <div class="columns is-12 is-multiline">
            <div class="column is-3">
              <b-field :label="$t('dispositifPublicitaire.declarationPrealable')">
                <b-datepicker show-week-number
                              nearby-selectable-month-days
                              icon="calendar-today"
                              v-model=
                                "dispositifPublicitaire.dispositifTechnique.declarationPrealable"
                              :editable="true">
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('dispositifPublicitaire.restrictionsAffichage')">
                <b-input v-model="dispositifPublicitaire.dispositifTechnique.restrictionsAffichage"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <div class="mgt-20px">
                <qd-checkbox v-model=dispositifPublicitaire.proprietaire class="mgt-10px">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('dispositifPublicitaire.appartenanceDispositif') }}
                  </p>
                </qd-checkbox>
              </div>
            </div>
            <div class="column is-3">
              <b-field :label="$t('dispositifPublicitaire.confrere')">
                <b-autocomplete
                  :value="libelleConfrere"
                  :open-on-focus="false"
                  :data="confreres"
                  field="nomCommercial"
                  :placeholder="$i18n.t('general.autocomplete.search')"
                  @input="getConfrere"
                  :loading="isFetching"
                  @select="setConfrere">
                  <template slot="empty">
                    <div v-if="!isFetching">
                      {{$t('general.autocomplete.noRslt')}}
                    </div>
                    <div v-else>
                      {{$t('general.autocomplete.search')}}
                    </div>
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
          </div>
          <div class="columns is-12 is-multiline">
            <div class="column is-5">
              <b-field :label="$t('dispositifPublicitaire.tags')" class="column is-12">
                <query-tags-tag-input
                  :tooltipLabel="$t('dispositifPublicitaire.tagInfo')"
                  position="is-right"
                  v-model="dispositifPublicitaire.tags"
                  field="tag"
                  :moduleTag="moduleTagDispositif">
                </query-tags-tag-input>
              </b-field>
            </div>
            <div class="column is-5" v-if="moduleSecteurActive">
              <secteur-lien-tag-input
                class="column is-12"
                v-model="dispositifPublicitaire.secteurs"
                :label="$t('dispositifPublicitaire.secteur')"
                :critere="secteurFilter">
                </secteur-lien-tag-input>
            </div>
            <div class="column is-2" v-if="afficherTempsFort">
              <div class="mgt-20px column is-12">
                <qd-checkbox v-model="dispositifPublicitaire.tempFort" class="mgt-10px">
                  <p class="has-text-default has-text-weight-bold">
                    {{ $t('dispositifPublicitaire.tempsFort') }}
                  </p>
                </qd-checkbox>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <montage-demontage :dispositifPublicitaire="dispositifPublicitaire">
        </montage-demontage>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('adresseEmplacement.adresse') }}
        </p>
      </header>
      <div class="card-content">
        <adresse :adresseCadastraleInformation="dispositifPublicitaire.adresse" :showTitle="false">
        </adresse>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('dispositifPublicitaire.divers.title') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('dispositifPublicitaire.divers.pdlElectricite')">
            <b-input v-model="dispositifPublicitaire.pdlElectricite"></b-input>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('dispositifPublicitaire.divers.iot')">
            <b-input v-model="dispositifPublicitaire.iot"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('dispositifPublicitaire.commentaire') }}
        </p>
      </header>
      <div class="card-content">
        <b-input type="textarea" v-model="dispositifPublicitaire.commentaire"></b-input>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('adresseEmplacement.pj') }}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes deletable
                            :checkPermissions=checkPermissions(permEmplacement.maj)>
        </app-pieces-jointes>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import Logo from '@/components/general/Logo';
import debounce from 'lodash/debounce';
import PiecesJointes from '@/components/general/piecesJointes';
import adresse from '@/components/gabed/emplacement/adresseCreationEmplacement';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import messageErreur from '@/services/general/messageErreur';
import getAllConfrere from '@/services/tiers/getAllConfrere';
import montageDemontage from '@/components/gabed/dispositif/montageDemontage';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { DISPOSITIF as moduleTagDispositif } from '@/configuration/parametrage/tagConf';
import secteurLienTagInput from '@/components/commun/secteur/secteurLienTagInput';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'm_infoGenerale',
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
  },
  components: {
    adresse,
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    montageDemontage,
    queryTagsTagInput,
    secteurLienTagInput,
    parametreAutocomplete,
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      confreres: [],
      libelleConfrere: null,
      isFetching: false,
      activeTab: 'InfoGenerale',
      moduleTagDispositif,
      secteurs: [],
      PARAMETRES_KEYS,
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getConfrere: debounce(async function confrereData(text) {
      if (text === this.libelleConfrere) return;
      try {
        this.libelleConfrere = text;
        this.dispositifPublicitaire.tiersId = null;
        this.isFetching = true;
        this.confreres = await getAllConfrere({
          societeId: this.societeActiveId,
          nomCommercial: text,
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }),
    secteurFilter(el) {
      return el.type === PATRIMOINE;
    },
    setConfrere(newConfrere) {
      if (!newConfrere) return;
      this.libelleConfrere = newConfrere.nomCommercial;
      this.dispositifPublicitaire.tiersId = newConfrere.id;
    },
    logoChanged(value) {
      this.$emit('hasNewLogo', value);
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    afficherTempsFort() {
      return this.moduleEmplacementClientActive
      && !!this.dispositifPublicitaire?.emplacement?.clientId;
    },
  },
  async mounted() {
    try {
      await this.setAttachmentContext({ module: 'Dispositif' });
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
      ]);
      if (this.$route.params.idDispositif) {
        await this.setAttachmentElementId({ id: this.$route.params.idDispositif });
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.dispositifPublicitaire.code }));
        this.libelleConfrere = this.dispositifPublicitaire.tiers
          ? this.dispositifPublicitaire.tiers.nomCommercial : null;
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
